"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeProperties = exports.dimensionAttributesEqual = exports.isDimensionAttribute = exports.isFinishAttribute = exports.isAttributeType = exports.AttributeType = void 0;
const t = __importStar(require("io-ts"));
const E = __importStar(require("fp-ts/lib/Either"));
const configurableProperties_1 = require("./configurableProperties");
// Attributes are currently using in Visual Inspiration representing the axes of variation throught which
// a product can be swapped to another variant
exports.AttributeType = t.keyof({
    finish: null,
    dimension: null,
});
const isAttributeType = (f) => {
    return E.isRight(exports.AttributeType.decode(f));
};
exports.isAttributeType = isAttributeType;
const BaseAttribute = t.type({ id: t.string, displayName: t.string });
const FinishAttribute = t.intersection([
    BaseAttribute,
    t.type({ attributeType: t.literal('finish'), hex: t.string }),
]);
const DimensionAttribute = t.intersection([
    BaseAttribute,
    t.type({
        attributeType: t.literal('dimension'),
        x: configurableProperties_1.DimensionValue,
        y: configurableProperties_1.DimensionValue,
        z: configurableProperties_1.DimensionValue,
    }),
]);
const Attribute = t.union([FinishAttribute, DimensionAttribute]);
const isFinishAttribute = (f) => {
    return E.isRight(FinishAttribute.decode(f));
};
exports.isFinishAttribute = isFinishAttribute;
const isDimensionAttribute = (f) => {
    return E.isRight(DimensionAttribute.decode(f));
};
exports.isDimensionAttribute = isDimensionAttribute;
const dimensionAttributesEqual = (a, b) => {
    return (a.displayName === b.displayName &&
        a.x.value === b.x.value &&
        a.y.value === b.y.value &&
        a.z.value === b.z.value);
};
exports.dimensionAttributesEqual = dimensionAttributesEqual;
exports.AttributeProperties = t.record(exports.AttributeType, t.type({ displayName: t.string, properties: t.array(Attribute) }));
